import { render, staticRenderFns } from "./AmendedTable.vue?vue&type=template&id=0c38b210"
import script from "./AmendedTable.vue?vue&type=script&lang=js"
export * from "./AmendedTable.vue?vue&type=script&lang=js"
import style0 from "./AmendedTable.vue?vue&type=style&index=0&id=0c38b210&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports